(() => {
  if (window.DcFramePreviewReady) return;
  window.DcFramePreviewReady = true;
  const storageKey = 'decollective:frame-preview';
  const validFrames = new Set(['none', 'oak', 'dark', 'black', 'white']);
  const savedFrame = () => {
    try {
      const value = localStorage.getItem(storageKey);
      return validFrames.has(value) ? value : 'oak';
    } catch (_) {
      return 'oak';
    }
  };
  const applyFrame = (group, frame) => {
    const button = [...group.querySelectorAll('[data-dc-frame]')].find(choice => choice.dataset.dcFrame === frame);
    if (!button) return;
    group.querySelectorAll('[data-dc-frame]').forEach(choice => {
      choice.setAttribute('aria-pressed', String(choice === button));
    });
    group.querySelectorAll('.dc-frame-preview__overlay').forEach(overlay => {
      const card = overlay.closest('[data-dc-frame-orientation]');
      if (card) card.dataset.dcPreviewFrame = frame;
      if (button.dataset.overlay) {
        overlay.src = button.dataset.overlay;
        overlay.hidden = false;
      } else {
        overlay.hidden = true;
        overlay.removeAttribute('src');
      }
    });
  };
  const initialize = root => {
    root.querySelectorAll('[data-dc-frame-preview]').forEach(group => applyFrame(group, savedFrame()));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-dc-frame]');
    if (!button) return;
    const group = button.closest('[data-dc-frame-preview]');
    if (!group) return;
    applyFrame(group, button.dataset.dcFrame);
    try { localStorage.setItem(storageKey, button.dataset.dcFrame); } catch (_) {}
  });
})();
